export var calculateGCD = function (firstNum, secondNum) {
    if (secondNum === 0) {
        return firstNum;
    }
    else {
        return calculateGCD(secondNum, firstNum % secondNum);
    }
};
export var reduceRatio = function (width, height) {
    if (typeof width === 'number' && typeof height === 'number' && (!isNaN(width) && !isNaN(height))) {
        var divisor = calculateGCD(width, height);
        if (width === height) {
            return '1:1';
        }
        else {
            return width / divisor + ':' + height / divisor;
        }
    }
    else {
        return null;
    }
};
//# sourceMappingURL=index.js.map